var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
//@ts-nocheck
import { Component } from "react";
import { ConfigProvider, Input } from 'antd';
import GoogleMapReact from "google-map-react";
import PlacesAutocomplete, { geocodeByAddress, getLatLng } from "react-places-autocomplete";
import Search from '../../../assets/Search.svg';
import "./Map.scss";
var marker;
class Map extends Component {
    constructor() {
        super(...arguments);
        this.state = {
            mapApiLoaded: false,
            mapInstance: null,
            mapApi: null,
            geoCoder: null,
            places: [],
            center: { lat: 24.713, lng: 46.675 },
            zoom: 11,
            address: "",
            draggable: true,
            lat: 24.713,
            lng: 46.675,
            gmapsLoaded: false,
        };
        this.initMap = () => {
            this.setState({
                gmapsLoaded: true,
            });
        };
        this._onClick = ({ x, y, lat, lng, event }) => {
            this.setState({
                lat: lat,
                lng: lng,
            });
            this.setCurrentLocation(true);
        };
        this.apiHasLoaded = (map, maps) => {
            this.setState({
                mapApiLoaded: true,
                mapInstance: map,
                mapApi: maps,
            });
            this.addMyLocationButton();
        };
        this.setAddress = (address) => {
            this.setState({ address: address });
        };
        this.handleSelect = (value) => __awaiter(this, void 0, void 0, function* () {
            const results = yield geocodeByAddress(value);
            const latLng = yield getLatLng(results[0]);
            this.setAddress(value);
            this.setState({
                center: { lat: latLng.lat, lng: latLng.lng },
                lat: latLng.lat,
                lng: latLng.lng,
            });
            this.state.mapInstance.setZoom(20);
        });
        this.updateAddress = () => {
            const { address, lat, lng } = this.state;
            this.setState({
                address: ''
            });
            this.props.onOk({ address: address, lat: lat, lng: lng });
        };
    }
    componentDidMount() {
        this.setCurrentLocation(false);
        window.initMap = this.initMap;
        const gmapScriptEl = document.createElement(`script`);
        gmapScriptEl.src = `https://maps.googleapis.com/maps/api/js?key=AIzaSyDtKbJ8frTCqg4LsSfO0GDPla_tmaO5Pmg&libraries=places&callback=initMap`;
        document.querySelector(`body`).insertAdjacentElement(`beforeend`, gmapScriptEl);
    }
    addMyLocationButton() {
        var controlDiv = document.createElement("div");
        var firstChild = document.createElement("button");
        firstChild.style.backgroundColor = "#fff";
        firstChild.style.border = "none";
        firstChild.style.outline = "none";
        firstChild.style.width = "38px";
        firstChild.style.height = "38px";
        firstChild.style.borderRadius = "2px";
        firstChild.style.boxShadow = "0 1px 4px rgba(0,0,0,0.3)";
        firstChild.style.cursor = "pointer";
        firstChild.style.marginRight = "12px";
        firstChild.style.padding = "0px";
        firstChild.title = "Your Location";
        controlDiv.appendChild(firstChild);
        var secondChild = document.createElement("div");
        secondChild.style.margin = "10px";
        secondChild.style.width = "18px";
        secondChild.style.height = "18px";
        secondChild.style.backgroundImage =
            "url(https://maps.gstatic.com/tactile/mylocation/mylocation-sprite-1x.png)";
        secondChild.style.backgroundSize = "180px 18px";
        secondChild.style.backgroundPosition = "0px 0px";
        secondChild.style.backgroundRepeat = "no-repeat";
        secondChild.id = "you_location_img";
        firstChild.appendChild(secondChild);
        this.state.mapInstance.controls[this.state.mapApi.ControlPosition.RIGHT_BOTTOM].push(controlDiv);
        firstChild.addEventListener("click", () => {
            this.setCurrentLocation(false);
        });
    }
    setCurrentLocation(isCordProvided) {
        navigator.geolocation.getCurrentPosition((position) => {
            if (position.coords.latitude !== null &&
                position.coords.longitude !== null &&
                this !== null &&
                this.state.mapApi !== null) {
                if (!isCordProvided) {
                    this.setState({
                        lat: position.coords.latitude,
                        lng: position.coords.longitude,
                    });
                }
                const geocoder = new this.state.mapApi.Geocoder();
                geocoder.geocode({
                    location: {
                        lat: parseFloat(this.state.lat),
                        lng: parseFloat(this.state.lng),
                    },
                }, (results, status) => {
                    const myLatlng = {
                        lat: this.state.lat,
                        lng: this.state.lng,
                    };
                    if (this !== null && this.state.mapInstance) {
                        this.state.mapInstance.setCenter(myLatlng);
                        this.state.mapInstance.setZoom(18);
                        if (marker) {
                            marker.setMap(null);
                        }
                        marker = new this.state.mapApi.Marker({
                            position: myLatlng,
                        });
                        marker.setMap(this.state.mapInstance);
                    }
                    if (status === "OK") {
                        if (results[0]) {
                            this.setAddress(results[0].formatted_address);
                        }
                        else {
                            console.log("Unable to get the coordinates1");
                        }
                    }
                    else {
                        console.log("Geocoder failed due to: " + status);
                    }
                });
            }
        }, function (error) {
            console.log("Unable to get the coordinates");
            console.log(error);
        });
    }
    render() {
        const { placeholder, rtl } = this.props;
        const defaultMapOptions = {
            fullscreenControl: false,
        };
        return (_jsxs("div", Object.assign({ className: 'storybook__Map--container' }, { children: [_jsx(PlacesAutocomplete, Object.assign({ value: this.state.address, onChange: this.setAddress, onSelect: this.handleSelect, searchOptions: { componentRestrictions: { country: ["sa"] } } }, { children: ({ getInputProps, suggestions, getSuggestionItemProps, loading, }) => (_jsxs(_Fragment, { children: [_jsx(ConfigProvider, Object.assign({ direction: rtl ? "rtl" : "ltr" }, { children: _jsx("div", Object.assign({ className: 'map__inputField', style: rtl ? { float: 'right', right: '40px' } : { float: 'left', left: '40px' } }, { children: _jsxs("div", Object.assign({ className: 'inputSection__withIcon', style: { direction: rtl ? 'rtl' : 'ltr' } }, { children: [_jsx(Input, Object.assign({ className: rtl ? 'input-section mapInput-right' : 'input-section mapInput-left', value: this.state.address }, getInputProps({
                                                placeholder: placeholder,
                                            })), void 0), _jsx("img", { src: Search, alt: 'icon', onClick: this.onSearchClick, style: rtl ? { left: '35px' } : { right: '30px' } }, void 0)] }), void 0) }), void 0) }), void 0), _jsxs("div", Object.assign({ className: 'map__suggestion', style: rtl ? { right: '42px' } : { left: '42px' } }, { children: [loading && _jsx("div", { children: "Loading..." }, void 0), suggestions.map((suggestion, index) => {
                                        const style = {
                                            backgroundColor: suggestion.active ? "#C3CED0" : "#fff",
                                            cursor: 'pointer',
                                            display: loading ? 'none' : 'block',
                                            padding: '5px 24px'
                                        };
                                        return (_jsx("div", Object.assign({}, getSuggestionItemProps(suggestion, { style }), { children: suggestion.description }), index));
                                    })] }), void 0)] }, void 0)) }), void 0), _jsx(GoogleMapReact, { center: this.state.center, zoom: this.state.zoom, draggable: this.state.draggable, options: defaultMapOptions, onClick: this._onClick, bootstrapURLKeys: {
                        key: 'AIzaSyDtKbJ8frTCqg4LsSfO0GDPla_tmaO5Pmg',
                        libraries: ["places", "geometry"],
                    }, yesIWantToUseGoogleMapApiInternals: true, onGoogleApiLoaded: ({ map, maps }) => this.apiHasLoaded(map, maps) }, void 0)] }), void 0));
    }
}
export default Map;
